module.exports = __webpack_public_path__ + "img/bg-wszg-bule.f6b492c0.png";